export const engagementAppGroupIdStructuralTemplateCanvasTemplateTerritories =
  "/engagement/:app_group_id/structural_template/canvas_template_territories";
